import * as yup from 'yup';

export const commonDirectDataInputValidation: { [x: string]: any; } = {
    masterType: yup.string().required("Missing."),
    opsDatetime: yup.string().required("Missing."),
    forwarderCode: yup.string().required("Missing."),
    truckerName: yup.string().required("Missing."),
    vehicleNo: yup.string().required("Missing."),
    amount: yup.number().nullable().min(0, 'Input Value should be range from 0.00 to 9,999,999.99.')
        .max(9999999.99, 'Input Value should be range from 0.00 to 9,999,999.99.')
};
export const saptDirectDataInputValidation: { [x: string]: any; } = {
    operatingTml: yup.string().required("Missing."),
};

export const createDirectDataInputValidation: { [x: string]: any; } = {
    ...commonDirectDataInputValidation,
};
export const createSaptDirectDataInputValidation: { [x: string]: any; } = {
    ...commonDirectDataInputValidation,
    ...saptDirectDataInputValidation,
};

export const createDirectDataInputValidationSchema = yup.object().shape(createDirectDataInputValidation);
export const createSaptDirectDataInputValidationSchema = yup.object().shape(createSaptDirectDataInputValidation);

